<template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>VENDORS</h2>
				</div>
				<v-btn @click.prevent="fncVendorExport" class="elevation-5" color="info"><i class="material-icons">file_copy</i>Export to Excel</v-btn>
				<v-btn @click.prevent="fncVendorAdd" class="elevation-5" color="info"><i class="material-icons">add</i>Create Vendor</v-btn>
				<v-btn @click.prevent="fncReloadVendors" class="elevation-5" color="info"><i class="material-icons">refresh</i></v-btn>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
			}
		},
		methods: {
      fncVendorExport() {
        this.$store.dispatch('fncPopulateDepartments');
        this.$store.dispatch({
          type: 'fncPopulateVendorsCsv'
        })
      },
          fncVendorAdd() {
            this.$store.dispatch('fncPopulateManufacturers');
				/*var modalDetails = { title: 'Add Vendor', component: 'modal-vendor-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});*/
          },
          fncReloadVendors() {
            this.$store.commit('fncEmptyVendors');
            this.$store.dispatch({
              type: 'fncPopulateVendors',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
        'vendorManufacturerRanges'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
